import { Box, Typography, useMediaQuery, useTheme } from '@mui/material'
import React from 'react'
import Chart1 from './Synthese/Chart1'
import Chart2 from './Synthese/Chart2'
import Chart3 from './Synthese/Chart3'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

export default function Synthese({ budgetRevenu }) {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  return (
    <div>
      <Typography sx={{ color: 'white', fontSize: 28, fontWeight: 900, mb: 0.5 }}>
        {t('finance.monBudget.syntheseTitle')}
      </Typography>
      <Typography sx={{ color: 'rgba(255,255,255,0.62)', fontSize: 14, mb: 2 }}>
        {t('finance.monBudget.syntheseSubtitle')}
      </Typography>
      <Box display={'grid'} gridTemplateColumns={isMobile ? '1fr' : '0.9fr 1.35fr'} gap={2}>
        <Box
          sx={{
            bgcolor: '#082348',
            border: '1px solid rgba(255,255,255,0.09)',
            borderRadius: 2,
            p: 2,
          }}
        >
          <Typography sx={{ color: 'white', fontWeight: 900, fontSize: 20 }}>{t('finance.monBudget.budgetState')}</Typography>
          <Typography sx={{ color: 'rgba(255,255,255,0.62)', fontSize: 13, mb: 1 }}>
            {t('finance.monBudget.budgetStateSubtitle')}
          </Typography>
          <Chart1 chartData={budgetRevenu.filter((e) => e.type === 'globalbudget')[0]?.data} />
        </Box>
        <Box
          sx={{
            bgcolor: '#082348',
            border: '1px solid rgba(255,255,255,0.09)',
            borderRadius: 2,
            p: 2,
          }}
        >
          <Typography sx={{ color: 'white', fontWeight: 900, fontSize: 20 }}>
            {t('finance.monBudget.consumptionByFamily')}
          </Typography>
          <Typography sx={{ color: 'rgba(255,255,255,0.62)', fontSize: 13, mb: 1 }}>
            {t('finance.monBudget.consumptionByFamilySubtitle')}
          </Typography>
          <Chart2
            chartData={budgetRevenu.filter((e) => e.type === 'ConsumptionClassification')[0]?.data}
          />
        </Box>
      </Box>
      <Box
        mt={2}
        sx={{
          bgcolor: '#082348',
          border: '1px solid rgba(255,255,255,0.09)',
          borderRadius: 2,
          p: 2,
        }}
      >
        <Typography sx={{ color: 'white', fontWeight: 900, fontSize: 20 }}>
          {t('finance.monBudget.distributionByCategory')}
        </Typography>
        <Typography sx={{ color: 'rgba(255,255,255,0.62)', fontSize: 13, mb: 1 }}>
          {t('finance.monBudget.distributionByCategorySubtitle')}
        </Typography>
        <Chart3
          chartData={budgetRevenu.filter((e) => e.type === 'ConsumptionByCategory')[0]?.data}
        />
      </Box>
    </div>
  )
}
